// @flow
import ga from 'app/common/lib/ga';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Thunk } from 'app/common/redux/types';
import { type Invite } from 'app/common/react/components/BoardCollab/types';

const GA_CATEGORY_APPROVE_INVITE = 'collaborator_approve_invite';

// TODO: (jonathanluo) Convert to use Redux store and actions

// TODO: (jonathanluo) convert to dispatchable actions
export function inviteEmails(boardId: string, emails: string[]) {
  return ResourceFactory.create('BoardEmailInviteResource', {
    board_id: boardId,
    emails,
  }).callCreate();
}

// TODO: (jonathanluo) convert to dispatchable actions
export function inviteUsers(boardId: string, userIds: string[]) {
  return ResourceFactory.create('BoardInviteResource', {
    board_id: boardId,
    invited_user_ids: userIds,
  }).callCreate();
}

export function approveBoardCollabInvite(boardId: string, invitedUserId: string): Thunk<void> {
  return (dispatch) => {
    const resource = ResourceFactory.create('BoardInviteResource', {
      board_id: boardId,
      invited_user_id: invitedUserId,
    });
    return resource
      .callUpdate()
      .then(() => {
        ga.trackEvent(GA_CATEGORY_APPROVE_INVITE, PCONST.GA_ACTION_SUCCESS);
      })
      .catch(() => ga.trackEvent(GA_CATEGORY_APPROVE_INVITE, PCONST.GA_ACTION_ERROR));
  };
}

export function deleteBoardCollabInvite(
  invite: Invite,
  isViewerInvitedUser: boolean,
  shouldBan: boolean,
): Thunk<void> {
  return (dispatch) => {
    const {
      invited_user,
      status,
      board: { id: boardId },
    } = invite;
    const resource = ResourceFactory.create(
      status === 'accepted' ? 'BoardCollaboratorResource' : 'BoardInviteResource',
      {
        ban: shouldBan,
        board_id: boardId,
        field_set_key: 'boardEdit',
        invited_user_id: invited_user.id,
      },
    ).callDelete({ showError: false });
    return resource;
  };
}
